// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".relationship-list-item__actions{display:none}.relationship-list-item:hover .relationship-list-item__actions{display:flex}.relationship-list-item__link-icon span,.relationship-list-item__edit-icon span{display:unset}", ""]);
// Exports
module.exports = exports;
